const ITEMS = [
  "ENTERPRISE AI",
  "LEGAL TECHNOLOGY",
  "HEALTHCARE SYSTEMS",
  "INSURANCE INFRASTRUCTURE",
  "PUBLIC SAFETY",
  "WORKFLOW AUTOMATION",
  "EVIDENCE INTELLIGENCE",
  "DECISION SYSTEMS",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 py-6 select-none"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-14 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-14">
            <span className="font-mono text-sm tracking-[0.25em] text-white/50">
              {item}
            </span>
            <span
              className="h-1.5 w-1.5 rounded-full"
              style={{ background: "var(--accent)" }}
            />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#040405] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#040405] to-transparent" />
    </div>
  );
}
